import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {share} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AccountSelectorWidgetExtendedService {
  // Observable string account
  public selectedAccount = new BehaviorSubject<string>('');

  // Observable string streams
  public selectedAccount$ = this.selectedAccount.asObservable().pipe(share());

  public setSelectedAccount(selectedAccount: string): void {
    this.selectedAccount.next(selectedAccount);
  }
}
